/**
 * HoraiPage — Port of horai.page.html (static horai grid)
 * Warm traditional theme
 */
import { useState } from 'react';

const T = {
  bgPage: '#f0f5e8', bgGreenPale: '#e8f5e9', bgCream: '#fffef0',
  bgSaffronLight: '#fff8e1', textGreenDark: '#1b5e20', textGreenDeep: '#0d3b0f',
  textMaroon: '#6d1b1b', accentOrange: '#e65100', borderGreen: '#c8e6c9',
  gold: '#f0d48a', headerBg: 'linear-gradient(135deg, #090b72, #1a237e)',
};

const horaiData1 = [
  ['6to7','சூரி','சந்','செவ்','புத'], ['7to8','சுக்','சனி','சூரி','சந்'],
  ['8to9','புத','குரு','சுக்','சனி'], ['9to10','சந்','செவ்','புத','குரு'],
  ['10to11','சனி','சூரி','சந்','செவ்'], ['11to12','குரு','சுக்','சனி','சூரி'],
  ['12to13','செவ்','புத','குரு','சுக்'], ['13to14','சூரி','சந்','செவ்','புத'],
  ['14to15','சுக்','சனி','சூரி','சந்'], ['15to16','புத','குரு','சுக்','சனி'],
  ['16to17','சந்','செவ்','புத','குரு'], ['17to18','சனி','சூரி','சந்','செவ்'],
  ['18to19','குரு','சுக்','சனி','சூரி'], ['19to20','செவ்','புத','குரு','சுக்'],
  ['20to21','சூரி','சந்','செவ்','புத'], ['21to22','சுக்','சனி','சூரி','சந்'],
  ['22to23','புத','குரு','சுக்','சனி'], ['23to24','சந்','செவ்','புத','குரு'],
  ['24to25','சனி','சூரி','சந்','செவ்'], ['25to26','குரு','சுக்','சனி','சூரி'],
  ['26to27','செவ்','புத','குரு','சுக்'], ['27to28','சூரி','சந்','செவ்','புத'],
  ['28to29','சுக்','சனி','சூரி','சந்'], ['29to30','புத','குரு','சுக்','சனி'],
];

const horaiData2 = [
  ['6to7','குரு','சுக்','சனி'], ['7to8','செவ்','புத','குரு'],
  ['8to9','சூரி','சந்','செவ்'], ['9to10','சுக்','சனி','சூரி'],
  ['10to11','புத','குரு','சுக்'], ['11to12','சந்','செவ்','புத'],
  ['12to13','சனி','சூரி','சந்'], ['13to14','குரு','சுக்','சனி'],
  ['14to15','செவ்','புத','குரு'], ['15to16','சூரி','சந்','செவ்'],
  ['16to17','சுக்','சனி','சூரி'], ['17to18','புத','குரு','சுக்'],
  ['18to19','சந்','செவ்','புத'], ['19to20','சனி','சூரி','சந்'],
  ['20to21','குரு','சுக்','சனி'], ['21to22','செவ்','புத','குரு'],
  ['22to23','சூரி','சந்','செவ்'], ['23to24','சுக்','சனி','சூரி'],
  ['24to25','புத','குரு','சுக்'], ['25to26','சந்','செவ்','புத'],
  ['26to27','சனி','சூரி','சந்'], ['27to28','குரு','சுக்','சனி'],
  ['28to29','செவ்','புத','குரு'], ['29to30','சூரி','சந்','செவ்'],
];

const subaColors = { 'குரு': '#2e7d32', 'சுக்': '#2e7d32' };
const getCellColor = (val) => subaColors[val] || T.textGreenDeep;

const cellStyle = { padding: '6px 4px', textAlign: 'center', borderBottom: `1px solid ${T.borderGreen}`, fontSize: '0.85rem' };
const headerStyle = { ...cellStyle, fontWeight: 800, backgroundColor: T.bgGreenPale, color: T.textGreenDark, borderBottom: `2px solid ${T.textGreenDark}` };

const HoraiPage = () => {
  const [tab, setTab] = useState('one');
  return (
    <div style={{ padding: '10px', background: T.bgPage, minHeight: '80vh' }}>
      <div style={{ background: T.headerBg, padding: '14px', borderRadius: '12px', textAlign: 'center', marginBottom: '12px', borderBottom: '3px solid #ff9800' }}>
        <h2 style={{ color: 'white', margin: 0, fontSize: '1.1rem', fontWeight: 800 }}>⏰ தின ஹோரைகளும் - பலன்களும்</h2>
        <div style={{ color: T.gold, fontSize: '0.85rem', marginTop: '4px' }}>Daily Horai & Benefits</div>
      </div>

      <div style={{ backgroundColor: T.bgSaffronLight, padding: '10px 12px', borderRadius: '10px', fontSize: '0.8rem', color: T.accentOrange, marginBottom: '12px', border: `1px solid #f9a825` }}>
        அன்றைய சூ.உதயப்படி கணக்கிட்டுக்கொள்க. ஒரு ஹோரை என்பது ஒரு மணி நேரம்.
        <strong> குரு, சுக்ர</strong>=சுபம் | <strong>சந்,ராகு,கேது</strong>=மத்திமம் | மற்றவை=அதமம்.
      </div>

      {/* Tab Switcher */}
      <div style={{ display: 'flex', marginBottom: '10px', borderRadius: '10px', overflow: 'hidden', border: `2px solid ${T.textGreenDark}` }}>
        <button onClick={() => setTab('one')} style={{
          flex: 1, padding: '10px', fontWeight: 800, fontSize: '0.85rem',
          backgroundColor: tab === 'one' ? T.textGreenDark : T.bgCream,
          color: tab === 'one' ? 'white' : T.textGreenDark, border: 'none', cursor: 'pointer'
        }}>ஞாயி-திங்-செவ்-புத</button>
        <button onClick={() => setTab('two')} style={{
          flex: 1, padding: '10px', fontWeight: 800, fontSize: '0.85rem',
          backgroundColor: tab === 'two' ? T.textGreenDark : T.bgCream,
          color: tab === 'two' ? 'white' : T.textGreenDark, border: 'none', cursor: 'pointer'
        }}>வியா-வெள்-சனி</button>
      </div>

      {/* Table */}
      <div style={{ backgroundColor: T.bgCream, borderRadius: '10px', overflow: 'hidden', border: `1px solid ${T.borderGreen}` }}>
        {tab === 'one' ? (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={headerStyle}>Time</th><th style={headerStyle}>ஞாயி</th><th style={headerStyle}>திங்</th><th style={headerStyle}>செவ்</th><th style={headerStyle}>புத→</th></tr></thead>
            <tbody>{horaiData1.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} style={{ ...cellStyle, color: j > 0 ? getCellColor(c) : T.textMaroon, fontWeight: j > 0 ? 600 : 700 }}>{c}</td>)}</tr>)}</tbody>
          </table>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={headerStyle}>Time</th><th style={headerStyle}>வியா</th><th style={headerStyle}>வெள்</th><th style={headerStyle}>சனி</th></tr></thead>
            <tbody>{horaiData2.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} style={{ ...cellStyle, color: j > 0 ? getCellColor(c) : T.textMaroon, fontWeight: j > 0 ? 600 : 700 }}>{c}</td>)}</tr>)}</tbody>
          </table>
        )}
      </div>
    </div>
  );
};
export default HoraiPage;
